// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"06db177c","295":"9e04d293"}[chunkId] + ".chunk.css";
};